import React, { createContext, useState } from 'react'
import ReactDOM from 'react-dom'

const AppContext = createContext()

const data = window.__data || {
  rooms: [
    {
      roomId: 'polish-pawn-sandbox',
      name: 'American Checkers [SB]',
      rules: {
        icon: 'american',
        name: 'American Checkers',
        boardSize: 8,
        longMoves: false,
        captureBackwards: false,
        captureMaxMandatory: false,
      },
    },
    {
      roomId: 'polish-pawn',
      name: 'American Checkers',
      rules: {
        icon: 'american',
        name: 'American Checkers',
        boardSize: 8,
        longMoves: false,
        captureBackwards: false,
        captureMaxMandatory: false,
      },
    },
    {
      roomId: 'polish-pawn-10-blitz',
      name: 'International Draughts',
      rules: {
        icon: 'international',
        name: 'International Draughts',
        boardSize: 10,
        longMoves: true,
        captureBackwards: true,
        captureMaxMandatory: true,
      },
    },
  ],
  signInPage: '/sign-in/',
}

const INIT_STATE = { data }

const AppContextProvider = ({ children }) => {
  const [app, setApp] = useState(INIT_STATE)
  app.exit = () => {
    document.body.classList.remove('in-game')
    ReactDOM.unmountComponentAtNode(document.getElementById('root')) 
  }

  return (
    <AppContext.Provider value={{ app, setApp }}>
      {children}
    </AppContext.Provider>
  )
}

const AppContextConsumer = AppContext.Consumer

export { AppContext, AppContextProvider, AppContextConsumer }
export default AppContext
